export default function() {
    return {
        posts: [],
        page: 1,
        totalPages: 0,
        perPage: 15,
        search: {},
        showDeleteConfirmation: false,
        deletingId: null,
        fields: [
            {
                key: 'title',
                label: 'Título'
            },
            {
                key: 'showFrom',
                label: 'Exibir a partir de'
            },
            {
                key: 'showUntil',
                label: 'Exibir até'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ]
    }
}
